import store from '@/store'
import ModuleBase from '../components/ModuleBase'
import SnowTrackerDashboard from '../views/Dashboard'
import AssignRoutes from '../views/AssignRoutes'
import SetupRoutes from '../views/SetupRoutes'

const routes = [
  {
    path: '/snow-tracker/',
    component: ModuleBase,
    meta: { appKey: 'snowtracker' },
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'dashboard',
        component: SnowTrackerDashboard,
        name: 'SnowTrackerDashboard'
      },
      {
        path: 'assign-routes/:stID',
        component: AssignRoutes,
        name: 'AssignRoutes'
      },
      {
        // id = scheduleID, stID = snowTracker ID
        path: 'setup-routes/:id/:stID',
        component: SetupRoutes,
        name: 'SetupRoutes'
      }
    ]
  }
]

export default routes
